export interface EmpresaDisenoTabContext {
  workflow: any | null;
  empresa: any | null;
  disenoPersonalizado?: boolean;
  workflowEmpresaId: number | null;
}

function isMatchingWorkflowEmpresa(entity: any, workflowEmpresaId?: string | number | null) {
  if (!entity || entity.id == null || workflowEmpresaId == null) return false;
  return String(entity.id) === String(workflowEmpresaId);
}

export function resolveEmpresaDisenoWorkflowEmpresa(
  empresaDiseno?: any,
  workflowEmpresa?: any,
  workflowEmpresaId?: string | number | null,
) {
  if (empresaDiseno?.profaseWorkflowEmpresa) return empresaDiseno.profaseWorkflowEmpresa;
  if (isMatchingWorkflowEmpresa(workflowEmpresa, workflowEmpresaId)) return workflowEmpresa;
  return null;
}

export function resolveEmpresaDisenoWorkflow(
  empresaDiseno?: any,
  workflowEmpresa?: any,
  workflowEmpresaId?: string | number | null,
) {
  const relation = resolveEmpresaDisenoWorkflowEmpresa(empresaDiseno, workflowEmpresa, workflowEmpresaId);
  return empresaDiseno?.profaseWorkflow
    ?? relation?.workflow
    ?? relation?.profaseWorkflow
    ?? null;
}

export function resolveEmpresaDisenoEmpresa(
  empresaDiseno?: any,
  workflowEmpresa?: any,
  workflowEmpresaId?: string | number | null,
) {
  return resolveEmpresaDisenoWorkflowEmpresa(empresaDiseno, workflowEmpresa, workflowEmpresaId)?.empresa ?? null;
}

export function resolveEmpresaDisenoPersonalizado(
  empresaDiseno?: any,
  workflowEmpresa?: any,
  workflowEmpresaId?: string | number | null,
): boolean | undefined {
  const relation = resolveEmpresaDisenoWorkflowEmpresa(empresaDiseno, workflowEmpresa, workflowEmpresaId);
  if (relation?.disenoPersonalizado != null) return !!relation.disenoPersonalizado;
  if (empresaDiseno?.disenoPersonalizado != null) return !!empresaDiseno.disenoPersonalizado;
  return undefined;
}

export function buildEmpresaDisenoTabContext(
  empresaDiseno?: any,
  workflowEmpresa?: any,
  workflowEmpresaId?: string | number | null,
): EmpresaDisenoTabContext {
  const relation = resolveEmpresaDisenoWorkflowEmpresa(empresaDiseno, workflowEmpresa, workflowEmpresaId);
  return {
    workflow: resolveEmpresaDisenoWorkflow(empresaDiseno, workflowEmpresa, workflowEmpresaId),
    empresa: resolveEmpresaDisenoEmpresa(empresaDiseno, workflowEmpresa, workflowEmpresaId),
    disenoPersonalizado: resolveEmpresaDisenoPersonalizado(empresaDiseno, workflowEmpresa, workflowEmpresaId),
    workflowEmpresaId: relation?.id != null ? Number(relation.id) : null,
  };
}

export function resolveEmpresaDisenoWorkflowEmpresaId(
  empresaDiseno?: any,
  workflowEmpresa?: any,
  workflowEmpresaId?: string | number | null,
): number | null {
  const id = resolveEmpresaDisenoWorkflowEmpresa(empresaDiseno, workflowEmpresa, workflowEmpresaId)?.id;
  return id != null && !Number.isNaN(Number(id)) ? Number(id) : null;
}

export function resolveEmpresaDisenoWorkflowId(
  empresaDiseno?: any,
  workflowEmpresa?: any,
  workflowEmpresaId?: string | number | null,
): number | null {
  const id = resolveEmpresaDisenoWorkflow(empresaDiseno, workflowEmpresa, workflowEmpresaId)?.id;
  return id != null && !Number.isNaN(Number(id)) ? Number(id) : null;
}

export function resolveEmpresaDisenoEmpresaId(
  empresaDiseno?: any,
  workflowEmpresa?: any,
  workflowEmpresaId?: string | number | null,
): number | null {
  const id = resolveEmpresaDisenoEmpresa(empresaDiseno, workflowEmpresa, workflowEmpresaId)?.id;
  return id != null && !Number.isNaN(Number(id)) ? Number(id) : null;
}

export function resolveEmpresaDisenoEmpresaLabel(
  empresaDiseno?: any,
  workflowEmpresa?: any,
  workflowEmpresaId?: string | number | null,
): string | undefined {
  const empresa = resolveEmpresaDisenoEmpresa(empresaDiseno, workflowEmpresa, workflowEmpresaId);
  if (!empresa) return undefined;
  return [empresa.rfc, empresa.razonSocial].filter(Boolean).join(' — ') || undefined;
}

export function resolveEmpresaDisenoWorkflowNombre(
  empresaDiseno?: any,
  workflowEmpresa?: any,
  workflowEmpresaId?: string | number | null,
): string | undefined {
  return resolveEmpresaDisenoWorkflow(empresaDiseno, workflowEmpresa, workflowEmpresaId)?.nombre?.trim() || undefined;
}
